/* eslint-disable @nx/enforce-module-boundaries */
import { provideHttpClient } from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
  isDevMode,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideRouter,
  withDebugTracing,
  withRouterConfig,
} from '@angular/router';
import * as AuthStore from '@kanzi-apes/kanzi-auth';
import { KanziUtilsModule } from '@kanzi-apes/kanzi-utils';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { environment } from '../environments/environment';
import * as LayoutReducer from './+state/layout/layout.reducer';
import { metaReducers, reducers } from './+state/reducers';
import { appRoutes } from './app.routes';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import {
  provideAngularQuery,
  QueryClient,
} from '@tanstack/angular-query-experimental';
import { ConfirmationService } from 'primeng/api';
import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';
import { provideServiceWorker } from '@angular/service-worker';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

const config: SocketIoConfig = {
  url: environment.socketIOServer ? environment.socketIOServer : '',
  options: { reconnection: false },
};

export const appConfig: ApplicationConfig = {
  providers: [
    ConfirmationService,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      appRoutes,
      withDebugTracing(),
      withRouterConfig({ onSameUrlNavigation: 'reload' })
    ),
    provideAnimations(),
    provideHttpClient(),
    importProvidersFrom(KanziUtilsModule.forRoot({ env: environment })),
    importProvidersFrom(
      StoreModule.forRoot(reducers, {
        metaReducers,
        runtimeChecks: {
          strictActionImmutability: true,
          strictStateImmutability: true,
        },
      })
    ),
    importProvidersFrom(
      StoreDevtoolsModule.instrument({
        name: 'Kanzi RFID DevTools',
        logOnly: environment.production,
        maxAge: 30,
        connectInZone: true,
      })
    ),
    importProvidersFrom(EffectsModule.forRoot([])),
    importProvidersFrom(KanziUtilsModule.forRoot({ env: environment })),
    importProvidersFrom(
      StoreModule.forFeature(
        LayoutReducer.LAYOUT_FEATURE_KEY,
        LayoutReducer.layoutReducer
      )
    ),
    importProvidersFrom(
      StoreModule.forFeature(AuthStore.AUTH_FEATURE_KEY, AuthStore.authReducer)
    ),
    importProvidersFrom(EffectsModule.forFeature(AuthStore.AuthEffects)),
    provideTranslateService({
      loader: provideTranslateHttpLoader(),
      fallbackLang: 'es',
      lang: 'es',
    }),
    provideAngularQuery(new QueryClient()),
    importProvidersFrom(SocketIoModule.forRoot(config)),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
};
